import { Link } from "react-router-dom";

const styles = {
  wrapper: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
    backgroundColor: "#f5f5f7",
    minHeight: "100vh",
    color: "#1d1d1f",
  },
  nav: {
    position: "sticky",
    top: 0,
    zIndex: 100,
    backgroundColor: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 40px",
    height: "52px",
  },
  navLogo: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1d1d1f",
    letterSpacing: "-0.5px",
    textDecoration: "none",
  },
  navLogoAccent: {
    color: "#2563eb",
  },
  backLink: {
    fontSize: "14px",
    color: "#2563eb",
    textDecoration: "none",
    fontWeight: "500",
  },
  hero: {
    background: "linear-gradient(160deg, #eff6ff 0%, #f5f5f7 100%)",
    padding: "64px 24px 56px",
    textAlign: "center",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  },
  heroLabel: {
    fontSize: "13px",
    fontWeight: "700",
    letterSpacing: "1.5px",
    color: "#2563eb",
    textTransform: "uppercase",
    marginBottom: "12px",
  },
  heroTitle: {
    fontSize: "clamp(32px, 5vw, 52px)",
    fontWeight: "800",
    letterSpacing: "-1.5px",
    color: "#1d1d1f",
    marginBottom: "16px",
  },
  heroSubtitle: {
    fontSize: "18px",
    color: "#6b7280",
    maxWidth: "500px",
    margin: "0 auto",
    lineHeight: 1.6,
  },
  content: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "64px 24px 96px",
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "20px",
    marginBottom: "64px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "32px 28px",
    border: "1px solid rgba(0,0,0,0.07)",
    textAlign: "center",
  },
  cardEmoji: {
    fontSize: "36px",
    display: "block",
    marginBottom: "14px",
  },
  cardTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#1d1d1f",
    marginBottom: "10px",
  },
  cardDesc: {
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: 1.65,
    marginBottom: "20px",
  },
  cardBtn: {
    display: "inline-block",
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    borderRadius: "10px",
    padding: "8px 18px",
    fontSize: "14px",
    fontWeight: "600",
    textDecoration: "none",
    border: "none",
    cursor: "pointer",
  },
  sectionTitle: {
    fontSize: "26px",
    fontWeight: "800",
    color: "#1d1d1f",
    letterSpacing: "-0.5px",
    marginBottom: "24px",
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "64px",
  },
  faqItem: {
    backgroundColor: "#fff",
    borderRadius: "14px",
    border: "1px solid rgba(0,0,0,0.07)",
    padding: "22px 28px",
  },
  faqQ: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1d1d1f",
    marginBottom: "8px",
  },
  faqA: {
    fontSize: "15px",
    color: "#6b7280",
    lineHeight: 1.7,
    margin: 0,
  },
  contactBox: {
    backgroundColor: "#1e3a8a",
    borderRadius: "24px",
    padding: "52px 40px",
    textAlign: "center",
    color: "#fff",
  },
  contactTitle: {
    fontSize: "28px",
    fontWeight: "800",
    letterSpacing: "-0.5px",
    marginBottom: "12px",
  },
  contactSubtitle: {
    fontSize: "16px",
    opacity: 0.75,
    marginBottom: "32px",
    lineHeight: 1.6,
  },
  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    maxWidth: "600px",
    margin: "0 auto",
  },
  contactItem: {
    backgroundColor: "rgba(255,255,255,0.1)",
    borderRadius: "14px",
    padding: "20px",
    border: "1px solid rgba(255,255,255,0.15)",
  },
  contactItemEmoji: {
    fontSize: "24px",
    display: "block",
    marginBottom: "8px",
  },
  contactItemLabel: {
    fontSize: "13px",
    fontWeight: "700",
    opacity: 0.7,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "4px",
  },
  contactItemValue: {
    fontSize: "14px",
    opacity: 0.85,
  },
  footer: {
    backgroundColor: "#1d1d1f",
    color: "rgba(255,255,255,0.4)",
    textAlign: "center",
    padding: "32px 24px",
    fontSize: "13px",
  },
  footerLink: {
    color: "rgba(255,255,255,0.45)",
    textDecoration: "none",
    margin: "0 12px",
  },
};

const supportFaqs = [
  {
    q: "How do I start recording a lecture?",
    a: "Open Omello, select your preferred AI model and context (Lecture, Meeting, or General), set your quiz interval, and press Record. The app will begin transcribing your session in real time.",
  },
  {
    q: "Why is the transcription inaccurate?",
    a: "Accuracy depends on microphone quality, background noise, and speaker clarity. For best results, use a good microphone and minimize noise. Cloud models generally provide higher accuracy than local models.",
  },
  {
    q: "How do I switch between local and cloud AI models?",
    a: "You can select your AI model at the start of each session. Local models run entirely on your device, while cloud models provide higher quality and require an internet connection.",
  },
  {
    q: "Can I delete a note or recording?",
    a: "Yes. Open a note, access the options menu, and select Delete. This will permanently remove all associated data from your device.",
  },
  {
    q: "The app is using a lot of CPU. What should I do?",
    a: "Larger local models require more processing power. You can switch to a smaller model or use a cloud model to reduce CPU usage.",
  },
  {
    q: "How do I generate a cram sheet?",
    a: "Select multiple notes from your notes list and choose 'Generate Cram Sheet'. Omello will summarize key points across all selected notes.",
  },
  {
    q: "My quizzes aren't very relevant. Why?",
    a: "Quiz quality depends on transcription quality and the AI model used. Try improving audio quality or using a more advanced model.",
  },
];

export default function Support() {
  return (
    <div style={styles.wrapper}>
      <nav style={styles.nav}>
        <Link to="/" style={styles.navLogo}>
          Om<span style={styles.navLogoAccent}>ello</span>
        </Link>
        <Link to="/" style={styles.backLink}>
          ← Back to Home
        </Link>
      </nav>

      <div style={styles.hero}>
        <p style={styles.heroLabel}>Help Center</p>
        <h1 style={styles.heroTitle}>Support</h1>
        <p style={styles.heroSubtitle}>
          We're here to help you get the most out of Omello.
        </p>
      </div>

      <div style={styles.content}>
        {/* Support Options */}
        <div style={styles.cardsGrid}>
          <div style={styles.card}>
            <span style={styles.cardEmoji}>📖</span>
            <h3 style={styles.cardTitle}>Documentation</h3>
            <p style={styles.cardDesc}>
              Learn how to use Omello’s features step by step.
            </p>
            <a href="mailto:ombalar123@gmail.com" style={styles.cardBtn}>
              Request Docs →
            </a>
          </div>

          <div style={styles.card}>
            <span style={styles.cardEmoji}>🐛</span>
            <h3 style={styles.cardTitle}>Report a Bug</h3>
            <p style={styles.cardDesc}>
              Found something not working? Let us know.
            </p>
            <a
              href="mailto:ombalar123@gmail.com?subject=Bug Report - Omello"
              style={styles.cardBtn}
            >
              Report Issue →
            </a>
          </div>

          <div style={styles.card}>
            <span style={styles.cardEmoji}>💡</span>
            <h3 style={styles.cardTitle}>Feature Requests</h3>
            <p style={styles.cardDesc}>
              Have an idea? We’d love to hear it.
            </p>
            <a
              href="mailto:ombalar123@gmail.com?subject=Feature Request - Omello"
              style={styles.cardBtn}
            >
              Share Idea →
            </a>
          </div>

          <div style={styles.card}>
            <span style={styles.cardEmoji}>✉️</span>
            <h3 style={styles.cardTitle}>Email Support</h3>
            <p style={styles.cardDesc}>
              Contact us directly for help.
            </p>
            <a href="mailto:ombalar123@gmail.com" style={styles.cardBtn}>
              Email Us →
            </a>
          </div>
        </div>

        {/* FAQ */}
        <h2 style={styles.sectionTitle}>Common Questions</h2>
        <div style={styles.faqList}>
          {supportFaqs.map((item, i) => (
            <div key={i} style={styles.faqItem}>
              <p style={styles.faqQ}>{item.q}</p>
              <p style={styles.faqA}>{item.a}</p>
            </div>
          ))}
        </div>

        {/* Contact Box */}
        <div style={styles.contactBox}>
          <h2 style={styles.contactTitle}>Still need help?</h2>
          <p style={styles.contactSubtitle}>
            Email us and we’ll get back to you as soon as possible.
          </p>

          <div style={styles.contactGrid}>
            <div style={styles.contactItem}>
              <span style={styles.contactItemEmoji}>✉️</span>
              <p style={styles.contactItemLabel}>Email</p>
              <p style={styles.contactItemValue}>
                ombalar123@gmail.com
              </p>
            </div>

            <div style={styles.contactItem}>
              <span style={styles.contactItemEmoji}>🕐</span>
              <p style={styles.contactItemLabel}>Response Time</p>
              <p style={styles.contactItemValue}>
                Typically within 1–2 days
              </p>
            </div>

            <div style={styles.contactItem}>
              <span style={styles.contactItemEmoji}>🌍</span>
              <p style={styles.contactItemLabel}>Availability</p>
              <p style={styles.contactItemValue}>
                Monday – Friday
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer style={styles.footer}>
        <p style={{ margin: "0 0 8px" }}>
          © {new Date().getFullYear()} Omello. All rights reserved.
        </p>
        <div>
          <Link to="/" style={styles.footerLink}>Home</Link>
          <Link to="/privacy-policy" style={styles.footerLink}>Privacy Policy</Link>
          <Link to="/support" style={styles.footerLink}>Support</Link>
        </div>
      </footer>
    </div>
  );
}